/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppUserDto } from '../../models/app-user-dto';

export interface UsersGet$Json$Params {
  search?: string;
  page?: number;
  pageSize?: number;
}

export function usersGet$Json(http: HttpClient, rootUrl: string, params?: UsersGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppUserDto>>> {
  const rb = new RequestBuilder(rootUrl, usersGet$Json.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AppUserDto>>;
    })
  );
}

usersGet$Json.PATH = '/users';
